import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CaravanRuins2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CARAVAN_RUINS2;
}

export default CaravanRuins2PoiTileEntity;
